const style = (theme) => {
  const transition = `all 1s ${theme.easings['power4.out']}`

  const output = {
    root: {
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: theme.zindex.header,
      transition: `all 0.3s ${theme.easings['power4.out']}`,
      pointerEvents: 'none',
      background: (props) => (props.headerInverse ? 'transparent' : theme.colors[1]),
      boxShadow: (props) => (props.headerInverse ? 'none' : `0px 0px 1px 1px ${theme.getRgba(theme.colors[0], 0.1)}`),
      '&$background': {
        background: (props) => (props.headerInverse ? theme.getRgba(theme.colors[0], 0.8) : theme.colors[1]),
        '& $logo': {
          '& svg': {
            fill: (props) => (props.headerInverse ? theme.colors[1] : theme.colors[0]),
          },
          '&:hover': {
            '& svg': {
              fill: () => (theme.colors[3]),
            },
          },
        },
        '& a': {
          color: (props) => (props.headerInverse ? theme.colors[1] : theme.colors[0]),
        },
      },
    },
    background: {},
    rootNavOpen: {},
    minimize: {
      background: 'transparent',
    },
    container: {
      margin: '0 auto',
      paddingTop: theme.header.top,
      paddingBottom: theme.header.bottom,
    },
    wrapper: {
      extend: theme.wrapper,
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      transition,
    },
    logo: {
      display: 'inline-block',
      pointerEvents: 'all',
      '& svg': {
        transition: `all 0.5s ${theme.easings['power4.out']}`,
        fill: (props) => (props.headerInverse ? theme.colors[1] : theme.colors[0]),
      },
      '&:hover': {
        '& svg': {
          fill: () => (theme.colors[3]),
        },
      },
    },
    nav: {
      display: 'flex',
      alignItems: 'center',
      pointerEvents: 'all',
      height: '100%',
    },
    headerNav: {
      display: 'flex',
      transition: `all 0.3s ${theme.easings['power4.out']}`,
      '& li': {
        marginRight: 40,
        fontSize: 14,
        display: 'flex',
        alignItems: 'center',
      },
      '& a': {
        display: 'flex',
        alignItems: 'center',
        lineHeight: 1.3,
        paddingTop: 7,
        paddingBottom: 7,
        color: (props) => (props.headerInverse ? theme.colors[1] : theme.colors[0]),
      },
    },
    btn: {
      backgroundColor: theme.colors[3],
      color: `${theme.colors[1]} !important`,
      paddingLeft: 15,
      paddingRight: 15,
      borderRadius: 6,
      fontSize: 10,
      textTransform: 'uppercase',
      transition: `all 0.3s ${theme.easings['power4.out']}`,
      '&:hover': {
        backgroundColor: theme.colors[4],
      },
    },
    burgerButton: {
      width: theme.header.burger.wrap,
      height: theme.header.burger.wrap,
      background: (props) => (props.headerInverse ? theme.colors[1] : theme.colors[0]),
      borderRadius: '50%',
      cursor: 'pointer',
      letterSpacing: 1,
      fontSize: 14,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: `all 0.3s ${theme.easings['power4.out']}`,
    },
    hide: {
      opacity: 0,
      pointerEvents: 'none',
    },
  }

  output[theme.mediaInverse.md] = {
    headerNav: {
      '& a': {
        display: 'none',
      },
    },
    btn: {
      display: 'block !important',
    },
  }

  output[theme.mediaInverse.sm] = {
    headerNav: {
      display: 'none',
    },
    logo: {},
    rootNavOpen: {
      background: 'transparent !important',
      boxShadow: `0px 0px 1px 1px ${theme.getRgba(theme.colors[0], 0.1)} !important`,
      '& $logo': {
        '& svg': {
          fill: `${theme.colors[2]} !important`,
        },
      },
    },
  }

  return output
}

export default style
